import { przezmorzeBatchApi, throwMessageOnBadRequestStatus } from "../../../../api/api";
import type { PriceType } from "../priceType";

export interface UploadCsvResponse {
  readonly optionCount: number;
}

export async function uploadCsvWithPrices(
  priceType: PriceType,
  body: FormData,
  abortSignal?: AbortSignal,
): Promise<UploadCsvResponse> {
  try {
    const response = await przezmorzeBatchApi.post<UploadCsvResponse>(`/prices/import/${priceType}`, body, {
      signal: abortSignal,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}
